import { ResizeObserver } from '~modules/browser'

class Dimension {
    constructor() {
        this._io = new ResizeObserver(this.onChange)

        this._targets = new Map()
    }

    onChange = (e)=>{
        for(const { target, contentRect } of e)
            if (this._targets.has(target))
                this._targets.get(target)(contentRect)
    }

    //public
    add = (target, callback)=>{
        if (!target) return
        if (this._targets.has(target)) return

        this._targets.set(target, callback)
        this._io.observe(target)
    }

    remove = (target)=>{
        if (!target) return
        this._targets.delete(target)
        this._io.unobserve(target)
    }
}

export const dimension = new Dimension()
